import { render, staticRenderFns } from "./MailWebView.vue?vue&type=template&id=f2681bc4&scoped=true"
import script from "./MailWebView.vue?vue&type=script&lang=js"
export * from "./MailWebView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2681bc4",
  null
  
)

export default component.exports